import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import Button from "wonderbly-components/lib/Button";
import CreationForm from "../../CreationForm";
import Modal from "../../Modal";
import RichText from "../../Prismic/RichText";

import "./CanvasDrawerContent.scss";

const CanvasDrawerContent = (props) => {
  if (!props.isOpen) {
    return null;
  }

  return (
    <Modal
      className="modal-canvas-drawer-content"
      bypass={!props.isModal}
      isOpen
    >
      <div
        data-hook={`canvas-drawer-${props.drawer.sliceType}-content`}
        className={cx("canvas-drawer-content", {
          "canvas-drawer-content--open": props.isOpen,
          "canvas-drawer-content--modal": props.isModal,
        })}
      >
        <div className="canvas-drawer-close">
          <Button type="button" unstyled onClick={props.onCancel}>
            {props.cancelCta || "Cancel"}
          </Button>
        </div>
        <div className="container-guttered">
          <div className="padded-top">
            <div className="canvas-drawer-title">
              <span className="canvas-drawer-title-main">
                {typeof props.title === "string" ? (
                  <p>{props.title}</p>
                ) : (
                  <RichText fields={props.title} />
                )}
              </span>
              {props.description && (
                <div className="canvas-drawer-title-description">
                  <RichText fields={props.description} />
                </div>
              )}
            </div>
            <div className="canvas-drawer-field">
              {props.isOpen && (
                <CreationForm
                  drawer={props.drawer}
                  form={props.form}
                  completedDrawersMap={props.completedDrawersMap}
                  onToggleDrawer={props.onToggleDrawer}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

CanvasDrawerContent.propTypes = {
  isModal: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  description: PropTypes.array,
  cancelCta: PropTypes.string.isRequired,
  completedDrawersMap: PropTypes.shape({
    all: PropTypes.arrayOf(PropTypes.string.isRequired),
    complete: PropTypes.arrayOf(PropTypes.string.isRequired),
    incomplete: PropTypes.arrayOf(PropTypes.string.isRequired),
  }),
  drawer: PropTypes.shape({
    sliceType: PropTypes.string.isRequired,
  }).isRequired,
  onCancel: PropTypes.func.isRequired,
  onToggleDrawer: PropTypes.func.isRequired,
  form: PropTypes.object,
  currentScrollPos: PropTypes.number.isRequired,
  productId: PropTypes.string.isRequired,
};

export default CanvasDrawerContent;
